import { Disc, Hash, Timer, QrCode, MapPin, Calendar, Layers, Trash2 } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const tyreSchema = defineSchema({
  id: 'tyres',
  title: 'filter.schema.tyres.title',
  subtitle: 'filter.schema.tyres.subtitle',
  defaultField: 'track',
  fields: {
    brand: {
      key: 'brand',
      label: 'filter.field.brand',
      type: 'enum',
      icon: Disc,
      allowMultiple: true,
      description: 'filter.desc.brand',
      options: [
        { value: 'Mojo', label: 'Mojo' },
        { value: 'Vega', label: 'Vega' },
        { value: 'LeCont', label: 'LeCont' },
        { value: 'Bridgestone', label: 'Bridgestone' },
        { value: 'MG', label: 'MG' },
        { value: 'Dunlop', label: 'Dunlop' },
      ],
      example: 'brand:Mojo',
    },
    type: {
      key: 'type',
      label: 'filter.field.tyreModel',
      type: 'text',
      icon: Layers,
      placeholder: 'filter.placeholder.tyreModel',
      description: 'filter.desc.tyreModel',
      example: 'type:D5',
    },
    compound: {
      key: 'compound',
      label: 'filter.field.compound',
      type: 'enum',
      icon: Disc,
      allowMultiple: true,
      description: 'filter.desc.compound',
      options: [
        { value: 'dry', label: 'filter.compound.dry' },
        { value: 'wet', label: 'filter.compound.wet' },
        { value: 'slick', label: 'filter.compound.slick' },
        { value: 'rain', label: 'filter.compound.rain' },
      ],
      example: 'compound:dry',
    },
    nr: {
      key: 'nr',
      label: 'filter.field.setNumber',
      type: 'number',
      icon: Hash,
      min: 1,
      max: 999,
      description: 'filter.desc.setNumber',
      example: 'nr:1',
    },
    laps: {
      key: 'laps',
      label: 'filter.field.totalLaps',
      type: 'range',
      icon: Timer,
      unit: 'filter.unit.laps',
      min: 0,
      max: 200,
      description: 'filter.desc.totalLaps',
      example: 'laps:0..20',
      presets: [
        { label: 'filter.preset.tyreFresh', value: '0', highValue: '15', operator: 'between' },
        { label: 'filter.preset.tyreBrokenIn', value: '16', highValue: '50', operator: 'between' },
        { label: 'filter.preset.tyreHighMileage', value: '50', operator: '>' },
      ],
    },
    barcode: {
      key: 'barcode',
      label: 'filter.field.barcode',
      type: 'text',
      icon: QrCode,
      placeholder: 'filter.placeholder.barcode',
      description: 'filter.desc.barcode',
      example: 'barcode:12345',
    },
    track: {
      key: 'track',
      label: 'filter.field.lastTrack',
      type: 'text',
      icon: MapPin,
      placeholder: 'filter.placeholder.track',
      description: 'filter.desc.lastTrack',
      example: 'track:Lonato',
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.date',
      example: 'from:2026-01-01',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last7d', value: '-7d' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
    discarded: {
      key: 'discarded',
      label: 'filter.field.discarded',
      type: 'enum',
      icon: Trash2,
      allowMultiple: false,
      description: 'filter.desc.discarded',
      options: [
        { value: 'false', label: 'filter.discarded.false' },
        { value: 'true', label: 'filter.discarded.true' },
      ],
      example: 'discarded:false',
    },
  },
  examples: [
    { q: 'discarded:false', desc: 'filter.example.activeTyres' },
    { q: 'brand:Mojo compound:dry', desc: 'filter.example.dryMojo' },
    { q: 'laps:>70', desc: 'filter.example.highMileage70' },
    { q: 'laps:0..20', desc: 'filter.example.freshTyres' },
    { q: 'track:Lonato from:2026-08-01', desc: 'filter.example.lonatoTyres' },
    { q: '(brand:Vega OR compound:wet)', desc: 'filter.example.vegaOrWet' },
  ],
});

